import React from 'react';
import {
  Stack,
  Alert,
  AlertTitle,
  Card,
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Link,
} from '@mui/material';
import {
  Info,
  Warning,
  WbSunny,
  Map,
  Description,
  Assignment,
  Security,
} from '@mui/icons-material';

const ResourceLink = ({ icon, primary, secondary, href, external }) => (
  <ListItemButton
    component={Link}
    href={href}
    target={external ? '_blank' : '_self'}
    rel={external ? 'noopener noreferrer' : ''}
    sx={{
      py: 1.5,
      px: 2,
      color: '#2e2e2e',
      textDecoration: 'none',
      '&:hover': {
        backgroundColor: 'rgba(53, 152, 183, 0.08)',
      },
    }}
  >
    <ListItemIcon sx={{ color: '#3598b7', minWidth: 40 }}>
      {icon}
    </ListItemIcon>
    <ListItemText
      primary={primary}
      secondary={secondary}
      primaryTypographyProps={{
        sx: { color: 'inherit', fontWeight: 500 },
      }}
      secondaryTypographyProps={{
        sx: { color: 'rgba(46, 46, 46, 0.7)' },
      }}
    />
  </ListItemButton>
);

const quickResources = [
  {
    title: 'Viktige Ressurser',
    items: [
      {
        icon: <Assignment />,
        primary: 'Mission Form Control (MFC)',
        secondary: 'Påkrevd før flyging',
        href: 'https://form.jotform.com/213212604878354',
        external: true,
      },
      {
        icon: <Security />,
        primary: 'Job Safety Analysis (JSA)',
        secondary: 'Sikkerhetsvurdering',
        href: 'https://form.jotform.com/213192990452357',
        external: true,
      },
      {
        icon: <Map />,
        primary: 'Safetofly.no',
        secondary: 'Sjekk naturreservat og andre restriksjoner',
        href: 'https://www.safetofly.no/',
        external: true,
      },
    ],
  },
  {
    title: 'Hurtiglenker',
    items: [
      {
        icon: <WbSunny />,
        primary: 'Værmelding',
        secondary: 'Sjekk værforhold',
        href: 'https://www.yr.no',
        external: true,
      },
      {
        icon: <Warning />,
        primary: 'NOTAM',
        secondary: 'Luftfartsmeldinger',
        href: 'https://notams.aim.faa.gov/notamSearch/',
        external: true,
      },
      {
        icon: <Description />,
        primary: 'Dronelogbook',
        secondary: 'Flylogg og vedlikehold',
        href: 'https://www.dronelogbook.com',
        external: true,
      },
    ],
  },
];

const ResourcesSidebar = () => {
  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Alert
        severity="warning"
        sx={{
          borderRadius: 0,
          boxShadow: 'none',
        }}
      >
        <AlertTitle>Nye NINOX Prosedyrer</AlertTitle>
        Oppdaterte prosedyrer for NINOX i Tromsø fra 26. mai 2023
      </Alert>

      {quickResources.map((section, index) => (
        <Card
          key={index}
          sx={{
            backgroundColor: '#ffffff',
            borderRadius: 0,
            boxShadow: 'none',
            border: '1px solid rgba(0, 0, 0, 0.12)',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ p: 2, borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}>
            <Typography
              variant="h6"
              sx={{ color: '#3598b7', fontWeight: 600, display: 'flex', alignItems: 'center' }}
            >
              <Info sx={{ mr: 1, fontSize: 20 }} />
              {section.title}
            </Typography>
          </Box>
          <List disablePadding sx={{ flex: 1 }}>
            {section.items.map((item, itemIndex) => (
              <React.Fragment key={itemIndex}>
                <ResourceLink {...item} />
                {itemIndex < section.items.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        </Card>
      ))}
    </Stack>
  );
};

export default ResourcesSidebar;

